import { useEffect } from "react";

export type ThemePref = "system" | "light" | "dark";

export function applyTheme(pref: ThemePref) {
  try {
    localStorage.setItem("gbc-theme", pref);
  } catch {
    /* stockage indisponible : le thème s'applique quand même pour la session */
  }
  const dark = pref === "dark" || (pref === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#0B0E12" : "#F4F5F8");
}

/** Synchronise le thème enregistré dans le profil et suit le thème système si demandé. */
export function useThemeSync(pref: ThemePref | undefined, density?: "comfortable" | "compact") {
  useEffect(() => {
    if (!pref) return;
    applyTheme(pref);
    if (pref !== "system") return;
    const mq = matchMedia("(prefers-color-scheme: dark)");
    const handler = () => applyTheme("system");
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [pref]);
  useEffect(() => {
    if (density) document.documentElement.dataset.density = density;
  }, [density]);
}
